
import template from './add_site_dialog.html';

var AddSiteViewModel = function(page)
{
	var self = this;
	self.page = page;

	this.site_id = ko.observable();
	this.site_name = ko.observable();
	this.site_ip = ko.observable();
	this.site_location = ko.observable();
}

var AddSiteClass = function(bindings)
{
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new AddSiteViewModel(this);
	this.name = 'Add Site';

	this.init = function() {
        if (typeof bindings.site_id != "undefined") {
            self.viewModel.site_id(bindings.site_id);
            self.viewModel.site_name(bindings.site_name);
            self.viewModel.site_ip(bindings.site_ip);
            self.viewModel.site_location(bindings.site_location);

        }
	};

	this.add_site = function() {
		$.postJSON('/sites/upsert', {  site_id:    self.viewModel.site_id(),
            site_name: self.viewModel.site_name(),
            site_ip :self.viewModel.site_ip(),
            site_location : self.viewModel.site_location()}, function(res) {
			self.close(false);
		});
	};

	this.onClose = function() { 
	};

	this.btnclose = function() {
		self.close(false);
	};


}

//Register the dialog
export default {
	name: 'AddSite',
	dialog_class: AddSiteClass,
	template: template
};

